module.exports = __webpack_public_path__ + "img/moon-medium.e00031cc.png";